// app/javascript/entrypoints/components/Tooltip.jsx
import React, { useRef, useState, useEffect } from 'react'

export default function Tooltip({ id, text, className = "" }) {
  const containerRef = useRef(null)
  const [visible, setVisible] = useState(false)
  const [coords, setCoords] = useState({ top: 0, left: 0, maxWidth: 320 })

  const computePosition = () => {
    const el = containerRef.current
    if (!el) return
    const rect = el.getBoundingClientRect()
    const bodyMargin = 8
    const tooltipWidth = 272 // ~w-64

    // Vertical placement just below the trigger, clamped to viewport
    const top = Math.min(
      window.innerHeight - bodyMargin,
      Math.max(bodyMargin, rect.top + rect.height + 6),
    )

    // Prefer left of trigger for right sidebar; otherwise prefer right unless it would overflow
    const inRightSidebar = !!el.closest('#pipeline-editor-right-sidebar')
    const preferLeft = inRightSidebar || rect.left > window.innerWidth / 2

    let left
    if (preferLeft) {
      left = rect.left - tooltipWidth - bodyMargin
      if (left < bodyMargin) left = rect.right + bodyMargin
    } else {
      left = rect.right + bodyMargin
      if (left + tooltipWidth > window.innerWidth - bodyMargin) left = rect.left - tooltipWidth - bodyMargin
    }

    // Final clamp to ensure on-screen
    left = Math.max(bodyMargin, Math.min(left, window.innerWidth - tooltipWidth - bodyMargin))
    const maxWidth = Math.min(window.innerWidth - bodyMargin * 2, 320)

    setCoords({ top, left, maxWidth })
  }

  const onEnter = () => {
    computePosition()
    setVisible(true)
  }

  const onLeave = () => setVisible(false)

  useEffect(() => {
    if (!visible) return
    const onResize = () => computePosition()
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onResize, true)
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('scroll', onResize, true)
    }
  }, [visible])

  return (
    <div id={id} className={className}>
      <span ref={containerRef} className="relative inline-flex" onMouseEnter={onEnter} onMouseLeave={onLeave}>
        <span
          className="ml-1 inline-flex w-4 h-4 items-center justify-center rounded-full border text-[10px] leading-none text-slate-600 border-slate-300 bg-white cursor-help"
          aria-label="Help"
        >
          ?
        </span>
      </span>
      {visible && (
        <div id={`${id}-popup`}
          className="fixed z-[9999] rounded-md border border-slate-200 bg-white p-2 text-xs text-slate-700 shadow-lg"
          style={{ top: coords.top, left: coords.left, width: 272, maxWidth: coords.maxWidth }}
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={onLeave}
        >
          {text}
        </div>
      )}
    </div>
  )
}


